import React, { useState } from 'react';
import { Container, Typography, Box, Paper, TextField, Button, Alert, Divider, Switch, FormControlLabel } from '@mui/material';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

function Settings() {
  const { currentUser, userData } = useAuth();
  const [username, setUsername] = useState(userData?.username || '');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [darkMode, setDarkMode] = useState(true);
  const [emailNotifications, setEmailNotifications] = useState(userData?.emailNotifications || false);

  const handleSaveProfile = async () => {
    if (!username.trim()) {
      setError('Username cannot be empty');
      return;
    }

    try {
      setError('');
      setLoading(true);
      const userRef = doc(db, 'users', currentUser.uid);
      await updateDoc(userRef, {
        username: username.trim(),
        emailNotifications
      });
      setSuccess('Profile updated successfully');
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      setError('Failed to update profile: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" sx={{ mb: 4, fontWeight: 'bold' }}>
        Settings
      </Typography>
      
      <Paper sx={{ p: 4, mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 3 }}>
          Profile Settings
        </Typography>
        
        {success && <Alert severity="success" sx={{ mb: 3 }}>{success}</Alert>}
        {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
        
        <Box sx={{ mb: 3 }}>
          <TextField
            label="Email"
            fullWidth
            value={currentUser?.email || ''}
            disabled
            sx={{ mb: 3 }}
          />
          
          <TextField
            label="Username"
            fullWidth
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            sx={{ mb: 3 }}
          />
          
          <Button 
            variant="contained" 
            onClick={handleSaveProfile}
            disabled={loading}
          >
            Save Changes
          </Button>
        </Box>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h6" sx={{ mb: 3 }}>
          Preferences
        </Typography>
        
        <Box>
          <FormControlLabel
            control={
              <Switch 
                checked={darkMode} 
                onChange={() => setDarkMode(!darkMode)}
                disabled={true} // Disabled for now
              />
            }
            label="Dark Mode"
          />
          
          <FormControlLabel
            control={
              <Switch 
                checked={emailNotifications} 
                onChange={() => setEmailNotifications(!emailNotifications)}
              />
            }
            label="Email Notifications"
          />
        </Box>
      </Paper>
      
      <Paper sx={{ p: 4, bgcolor: '#1e1e1e' }}>
        <Typography variant="h6" sx={{ mb: 3, color: '#ff5252' }}>
          Danger Zone
        </Typography>
        
        <Button 
          variant="outlined" 
          color="error"
          sx={{ borderColor: '#ff5252', color: '#ff5252' }}
        >
          Delete Account
        </Button>
      </Paper>
    </Container>
  );
}

export default Settings; 